export default {
  props: {
    value: Number,
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 99,
    },
  },
  methods: {
    incrementDown: function (e) {
      this.$emit(
        'change',
        this.value - 1 < this.min ? this.min : this.value - 1,
      );
    },
    incrementUp: function (e) {
      this.$emit('change', this.value + 1);
    },
  },
  template: `
  <div class="quantity-selector">
    <button
      class="quantity-selector__action quantity-selector__action--decrement"
      type="button"
      v-on:click="incrementDown"
      :disabled="value <= min">
      <span class="quantity-selector__action__text">&minus;</span>
    </button>
    <p class="quantity-selector__field p1 bold" v-html="value" />
    <button
      class="quantity-selector__action quantity-selector__action--increment"
      type="button"
      v-on:click="incrementUp"
      :disabled="value >= max">
      <span class="quantity-selector__action__text">&plus;</span>
    </button>
  </div>
  `,
};
